import { Pinia, Store } from 'pinia-class-component';
import { InventoryStockTaking, InventoryStockTakingsUiClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'InventoryStockTakingStore',
  name: 'InventoryStockTakingStore',
})
export default class InventoryStockTakingStore extends Pinia {
  private readonly inventoryStockTakingApi = initClient(InventoryStockTakingsUiClient);

  //data
  private _loadingPromise: Promise<InventoryStockTaking[]> | null = null;
  private _stockTakings: InventoryStockTaking[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get stockTakings(): InventoryStockTaking[] {
    return this._stockTakings;
  }

  //actions
  clear(): void {
    this._stockTakings.splice(0);
  }

  setStockTakings(inventoryStockTakings: InventoryStockTaking[]): void {
    this._stockTakings.splice(0);
    this._stockTakings.push(...inventoryStockTakings);
  }

  remember(inventoryStockTaking: InventoryStockTaking): void {
    const index = this._stockTakings.findIndex(e => e.id == inventoryStockTaking.id);
    if (index >= 0) {
      this._stockTakings.splice(index, 1, inventoryStockTaking);
    } else {
      this._stockTakings.push(inventoryStockTaking);
    }
  }

  forget(inventoryStockTaking: InventoryStockTaking): void {
    const index = this._stockTakings.findIndex(e => e.id == inventoryStockTaking.id);
    if (index >= 0) {
      this._stockTakings.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.inventoryStockTakingApi.list(undefined);
      const duties = await this._loadingPromise;
      this.setStockTakings(duties);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._stockTakings.length > 0) {
      return;
    }
    return await this.reload();
  }
}